import { BaseTypeModel } from "@/interface";
import { reactive } from "vue";

export const documentType: Array<BaseTypeModel> = reactive([
    { name: '车间领料', id: 1 },
    { name: '车间转库', id: 5 },
    { name: '外协领料转库', id: 6 },
    { name: '外协完工转库', id: 7 },
    { name: '产品入库', id: 8 },
    { name: '产品转库', id: 9 },
    { name: '让步放行入库', id: 10 },
    { name: '让步放行转库', id: 11 },
    { name: '客返返修领料', id: 12 },
    { name: '客返返修入库', id: 13 },
    { name: '跨组织转库', id: 14 },
    { name: '客退返修领料', id: 16 },
    { name: '客退返修入库', id: 17 },
    { name: '废品入库', id: 30 }
])

export const orderType: Array<BaseTypeModel> = reactive(
[
    { name: '车间领料', id: 1 },
    { name: '计划领料', id: 2 },
    { name: '机台备料', id: 3 },
    { name: '完工入库', id: 4 },
    { name: '车间转库', id: 5 },
    { name: '外协领料转库', id: 6 },
    { name: '外协完工转库', id: 7 },
    { name: '产品入库', id: 8 },
    { name: '产品转库', id: 9 },
    { name: '让步放行入库', id: 10 },
    { name: '让步放行转库', id: 11 },
    { name: '客返返修领料', id: 12 },
    { name: '客返返修入库', id: 13 },
    { name: '跨组织转库', id: 14 },
    { name: '工序报废', id: 15 },
    { name: '客退返修领料', id: 16 },
    { name: '客退返修入库', id: 17 },
    { name: '销售出库', id: 18 },
    { name: '让步销售', id: 19 },
    { name: '工单投料', id: 20 },
    { name: '仓库报废', id: 21 },
    { name: '客退检验领料', id: 22 },
    { name: '客返检验领料', id: 23 },
    { name: '工单产出', id: 24 },
    { name: '采购入库', id: 25 },
    { name: '客退检验入库', id: 26 },
    { name: '客返检验入库', id: 27 },
    { name: '库存调整', id: 28 },
    { name: '废品入库', id: 30 }
  ]
)

export const orderTyepToStr = (type: number): string => {
  //  <!-- 1、车间领料；2、车间备料；3、其他；4、完工入库 -->
  for (const item of orderType) {
    if (item.id === type) {
      return item.name
    }
  }
  return '-'
}

